
export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Immunity Booster',
      description: 'Rich in vitamin C and antioxidants to strengthen your natural defenses'
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Energy Enhancement',
      description: 'Natural source of iron and B vitamins for sustained energy throughout the day'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Heart Health',
      description: 'Supports cardiovascular wellness with potassium and healthy compounds'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Anti-Inflammatory',
      description: 'Natural compounds help reduce inflammation and support overall wellness'
    },
    {
      icon: 'ri-brain-line',
      title: 'Mental Clarity',
      description: 'Nutrients that support cognitive function and mental well-being'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Digestive Support',
      description: 'Fiber and nutrients that promote healthy digestion and gut health'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose Moringa?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Moringa is often called the "miracle tree" for good reason. Packed with over 90 nutrients, 
            it's one of nature's most complete superfoods.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center p-6 rounded-xl hover:bg-emerald-50/50 transition-colors duration-300">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${benefit.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-emerald-700 py-3 px-6">
          <div className="flex items-center justify-between max-w-7xl mx-auto">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-plant-line text-xl text-emerald-700"></i>
              </div>
              <div className="text-white">
                <h3 className="text-base font-semibold">Our Planet Pledge</h3>
                <p className="text-sm text-white/90">For every product sold, we plant a tree.</p>
              </div>
            </div>
            <div className="text-right text-white">
              <div className="text-3xl font-bold">12,556</div>
              <div className="text-xs text-white/80 uppercase tracking-wide">TREES PLANTED & COUNTING</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
